import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget
} from '@tableau/widgets';
import React from 'react';

  import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyRestoreView } from '../components/KMSKeyRestoreView';


export const openKMSKeyRestorePolicyDialog = (dataKeyId: string): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.credentialEncryption_KMSKeyRestoreDialog_Title(),
              testId: 'data-key-restore-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width500px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, dataKeyId);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, dataKeyId: string) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSKeyRestoreView closeDialog={closeAndDismiss} dataKeyId={dataKeyId} />}
      </DialogWidget>
    );
  }